/* ADA / WCAG 2.1 AA fixes — added Oct 2026.
 * Progressive enhancement over the compiled Svelte components:
 *  - Color/size "chips" become a keyboard-operable radio group (2.1.1, 4.1.2)
 *  - Quantity select gets an accessible name (1.3.1, 3.3.2)
 *  - SKU-code alt text on product images replaced with product name + color (1.1.1)
 * The ideal long-term fix is to port this into the Svelte source (product-form).
 */
(function () {
  'use strict';
  var uid = 0;

  function chipText(chip) {
    var t = chip.querySelector('.virtual-select-option-text');
    return ((t ? t.textContent : chip.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function sync(group) {
    var chips = group.querySelectorAll('.chips-option');
    var anySelected = false;
    for (var i = 0; i < chips.length; i++) {
      var sel = chips[i].classList.contains('selected');
      if (sel) anySelected = true;
      chips[i].setAttribute('aria-checked', sel ? 'true' : 'false');
      var txt = chipText(chips[i]);
      if (txt && chips[i].getAttribute('aria-label') !== txt) chips[i].setAttribute('aria-label', txt);
      chips[i].setAttribute('tabindex', sel ? '0' : '-1');
      var disabled = chips[i].classList.contains('disabled') || chips[i].classList.contains('unavailable');
      if (disabled) chips[i].setAttribute('aria-disabled', 'true');
      else chips[i].removeAttribute('aria-disabled');
    }
    if (!anySelected && chips[0]) chips[0].setAttribute('tabindex', '0');
  }

  function enhanceGroup(group) {
    if (group.getAttribute('data-ada')) { sync(group); return; }
    group.setAttribute('data-ada', '1');
    group.setAttribute('role', 'radiogroup');

    // Name the group from the visible label, e.g. "Select Color: Azure" -> "Select Color"
    var wrap = group.closest('.selector-wrapper') || group.parentElement;
    var label = wrap && wrap.querySelector('label');
    if (label) {
      var bold = label.querySelector('.bold');
      var name = ((bold ? bold.textContent : label.textContent) || '').replace(/\s+/g, ' ').trim().replace(/\s*[:：]\s*$/, '');
      if (name) group.setAttribute('aria-label', name);
    }

    var chips = group.querySelectorAll('.chips-option');
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('role', 'radio');
    }

    group.addEventListener('keydown', function (e) {
      var chip = e.target.closest && e.target.closest('.chips-option');
      if (!chip) return;
      var list = Array.prototype.slice.call(group.querySelectorAll('.chips-option'));
      var idx = list.indexOf(chip);
      var next = null;
      switch (e.key) {
        case ' ':
        case 'Enter':
          e.preventDefault();
          chip.click();
          setTimeout(function () { sync(group); }, 50);
          return;
        case 'ArrowRight':
        case 'ArrowDown':
          next = list[(idx + 1) % list.length]; break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = list[(idx - 1 + list.length) % list.length]; break;
        case 'Home':
          next = list[0]; break;
        case 'End':
          next = list[list.length - 1]; break;
        default:
          return;
      }
      e.preventDefault();
      next.click();
      next.focus();
      setTimeout(function () { sync(group); next.focus(); }, 50);
    });

    group.addEventListener('click', function () {
      setTimeout(function () { sync(group); }, 50);
    });

    sync(group);
  }

  function labelQuantity() {
    var q = document.querySelectorAll('select[name="quantity"], input[name="quantity"]');
    for (var i = 0; i < q.length; i++) {
      var el = q[i];
      if (!el.getAttribute('aria-label') && !(el.labels && el.labels.length)) {
        el.setAttribute('aria-label', 'Quantity');
      }
    }
  }

  function labelSelects() {
    // Visible native selects without a name (e.g. sort/filter dropdowns)
    var s = document.querySelectorAll('select:not([aria-label]):not([aria-labelledby])');
    for (var i = 0; i < s.length; i++) {
      if (s[i].labels && s[i].labels.length) continue;
      var wrap = s[i].closest('.selector-wrapper');
      var label = wrap && wrap.querySelector('label');
      if (label) {
        if (!label.id) label.id = 'ada-lbl-' + (++uid);
        s[i].setAttribute('aria-labelledby', label.id);
      }
    }
  }


  /* ---- 1.1.1 Alt text: product images use SKU codes as alt (e.g. "PWAS1812-AZU").
   * Those codes are used by the image gallery to match images to variants, so the
   * product data is left untouched; only the rendered alt attribute is rewritten. */
  var productCache = {};
  function isCodeAlt(alt) {
    if (!alt) return false;
    if (/^Product with title /i.test(alt)) return true;
    var toks = alt.trim().split(/\s+/);
    for (var i = 0; i < toks.length; i++) {
      if (!/^[A-Z0-9][A-Z0-9\-_.\/]*$/.test(toks[i]) || !/[0-9\-]/.test(toks[i])) return false;
    }
    return toks.length > 0;
  }
  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getProduct(handle) {
    if (!handle) return null;
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function describe(product, alt) {
    var colorIdx = -1;
    (product.options || []).forEach(function (o, i) {
      var n = (o && (o.name || o)) + '';
      if (/colou?r/i.test(n)) colorIdx = i;
    });
    var colors = [];
    (product.variants || []).forEach(function (v) {
      if (v.sku && alt.indexOf(v.sku) !== -1 && colorIdx > -1) {
        var c = v.options[colorIdx];
        if (c && colors.indexOf(c) === -1) colors.push(c);
      }
    });
    var title = product.title || '';
    return colors.length ? title + ' in ' + colors.join(', ') : title;
  }
  function fixAlts() {
    var imgs = document.querySelectorAll('img[alt]');
    var pageHandle = handleFromHref(location.pathname);
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        var alt = img.getAttribute('alt');
        // "Egyptian Collar Pillow - PWEG2424-NIL TH" -> "Egyptian Collar Pillow"
        var m = /^(.*[a-z].*?)\s+[-–|]\s+(\S.*)$/.exec(alt || '');
        if (m && isCodeAlt(m[2].replace(/\b[A-Z]{1,3}\b/g, function (t) { return t + '-'; }))) {
          img.setAttribute('alt', m[1]); img.setAttribute('data-ada-alt', m[1]); return;
        }
        if (!isCodeAlt(alt) || img.getAttribute('data-ada-alt') === alt) return;
        var link = img.closest('a[href*="/products/"]');
        var handle = link ? handleFromHref(link.getAttribute('href')) : pageHandle;
        if (!handle) {
          // Codes alone mean nothing to a screen reader; treat as decorative.
          img.setAttribute('alt', ''); img.setAttribute('data-ada-alt', ''); return;
        }
        var p = getProduct(handle);
        if (!p) return;
        p.then(function (product) {
          if (!product || img.getAttribute('alt') !== alt) return;
          var text = describe(product, alt);
          if (text) { img.setAttribute('alt', text); img.setAttribute('data-ada-alt', text); }
        });
      })(imgs[i]);
    }
  }

  function run() {
    var groups = document.querySelectorAll('.chips-wrapper');
    for (var i = 0; i < groups.length; i++) enhanceGroup(groups[i]);
    labelQuantity();
    labelSelects();
    fixAlts();
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['alt'] });
})();
